import type { MultipleDeviceGroup } from './multipleDeviceTypes'

export const DEMO_MULTIPLE_DEVICES: MultipleDeviceGroup[] = [
  {
    id: 'md-1',
    deviceId: 'a3f8c2e19b0d4a7e',
    playerCount: 4,
    players: [
      { username: 'demo@fancy', accessLevel: 'Player', siteUrl: 'winner7', isCheater: false },
      { username: 'rk.pl02', accessLevel: 'Player', siteUrl: 'playtowin', isCheater: true },
      { username: 'rk.pl09', accessLevel: 'Player', siteUrl: 'winner7', isCheater: false },
      { username: 'rk.mn04', accessLevel: 'Master', siteUrl: 'winner7', isCheater: false },
    ],
  },
  {
    id: 'md-2',
    deviceId: 'bb12de90aa4411ff',
    playerCount: 3,
    players: [
      { username: 'cash@inr', accessLevel: 'Player', siteUrl: 'matrixexch9', isCheater: false },
      { username: 'cash@demo', accessLevel: 'Player', siteUrl: 'matrixexch9', isCheater: false },
      { username: 'nightowl', accessLevel: 'Player', siteUrl: '77exch', isCheater: false },
    ],
  },
  {
    id: 'md-3',
    deviceId: '00deadbeefcafe01',
    playerCount: 2,
    players: [
      { username: 'fair.user1', accessLevel: 'Player', siteUrl: 'Fairplay', isCheater: false },
      { username: 'fair.user2', accessLevel: 'Player', siteUrl: 'Fairplay', isCheater: true },
    ],
  },
  {
    id: 'md-4',
    deviceId: 'fprint-9c8b7a6d5e',
    playerCount: 5,
    players: [
      { username: 'deal.pl1', accessLevel: 'Player', siteUrl: 'deal999', isCheater: false },
      { username: 'deal.pl2', accessLevel: 'Player', siteUrl: 'deal999', isCheater: false },
      { username: 'deal.pl3', accessLevel: 'Player', siteUrl: 'deal999', isCheater: false },
      { username: 'deal.pl4', accessLevel: 'Player', siteUrl: 'winner7', isCheater: false },
      { username: 'sm.watch', accessLevel: 'SuperMaster', siteUrl: 'winner7', isCheater: false },
    ],
  },
  {
    id: 'md-5',
    deviceId: 'shared-phone-7788',
    playerCount: 2,
    players: [
      { username: 'twin.a', accessLevel: 'Player', isCheater: false },
      { username: 'twin.b', accessLevel: 'Player', isCheater: false },
    ],
  },
]
